module.exports = __webpack_public_path__ + "img/warning.c46c4a6b.svg";